import { useQuery } from '@tanstack/react-query'
import { fetchApiWithToken } from '~/api/utils'
import type { ApplicantFormation } from '~/domains/applicants/types'

export const useApplicantFormations = (applicantId?: number) => {
  return useQuery({
    queryKey: ['applicant', applicantId, 'formations'],
    queryFn: () =>
      fetchApiWithToken<ApplicantFormation[]>({
        method: 'get',
        url: `/v1/applicants/${applicantId}/formations?itemsPerPage=500`
      }),
    enabled: !!applicantId
  })
}
